// Hero section content
export const homeObjOne = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  hello: true,
  headline: " I'm",
  // Roles cycled by the typing effect in the hero
  roles: [
    "Fullstack Product Engineer",
    "0 → 1 Product Builder",
    "Web & Mobile Developer",
    "Product-First Builder",
  ],
  description:
    "I build and ship web & mobile products from zero to production — with a product-first mindset.",
  buttonLabel: "Get in Touch",
  cvUrl: "/Enes_Gungor_CV_2026.pdf",
  imgStart: "",
  alt: "Enes Güngör",
  start: "",
};

// About section content
export const homeObj2 = {
  primary: true,
  lightBg: true,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  topLine: "Who I am",
  headline: "Fullstack Product Engineer",
  description:
    "I'm Enes Güngör — a Fullstack Product Engineer with 6+ years of hands-on experience shipping web and mobile applications. I've co-founded an AI-powered content platform and taken products from zero to production across multiple startups while contributing to academic R&D. I'm fluent in Turkish and English, currently studying Business Administration & MIS at Özyeğin University (100% scholarship, 3.81 GPA) and spending the spring on a top-5 Erasmus placement at Tilburg University in the Netherlands.",
  highlights: [
    { value: "6+", label: "Years building" },
    { value: "10+", label: "Companies & startups" },
    { value: "3.81", label: "GPA / 4.0" },
    { value: "Top 5", label: "Erasmus placement" },
  ],
  buttonLabel: "Learn More",
  imgStart: "start",
  alt: "Enes Güngör",
  start: "start",
};
